import React from "react";
import {
  Box,
  Container,
  TextField,
  Button,
  Typography,
  Grid,
  Paper,
  useTheme,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";

const Contact = () => {
  const theme = useTheme();

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 12 }}>
        <Box
          sx={{
            height: 400,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            backgroundImage: `url(banner2.webp)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "#fff",
            textAlign: "center",
            p: 3,
            marginTop: 2,
            "&:before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1,
            },
          }}
        >
          <Box sx={{ position: "relative", zIndex: 1 }}>
            <Typography variant="h2" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="h6" gutterBottom>
              Get in touch with Foody
            </Typography>
          </Box>
        </Box>
      </Container>
      <Container maxWidth="md" sx={{ my: theme.spacing(4) }}>
        <Paper elevation={3} sx={{ p: theme.spacing(4) }}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box component="form" noValidate sx={{ mt: 1 }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="name"
                  label="Name"
                  name="name"
                  autoComplete="name"
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email Address"
                  name="email"
                  autoComplete="email"
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  multiline
                  rows={4}
                  id="message"
                  label="Message"
                  name="message"
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Submit
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
              <Typography variant="h6" gutterBottom>
                <LocationOnIcon /> Address
              </Typography>
              <Typography variant="body1" gutterBottom>
                123 Foody Street, Food Town
              </Typography>
              <Typography variant="h6" gutterBottom>
                <PhoneIcon /> Phone
              </Typography>
              <Typography variant="body1" gutterBottom>
                +1 234 567 890
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </>
  );
};

export default Contact;
